import { PropsWithChildren } from "react";

import { css } from "@compiled/react";

export const SvgContainer = (props: PropsWithChildren) => {
    const styles = css({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        svg: {
            display: "block",
            marginBlockEnd: 0,
            width: "100%",
            maxWidth: "36px"
        }
    });

    return <div css={styles}>{props.children}</div>;
};
